import React from 'react';

function Secure(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12.6128 2.37753L12.125 2.37476C9.49666 2.3514 6.88704 2.88345 4.47333 3.93686C3.79596 4.24742 3.37001 4.91559 3.37498 5.64892L3.37497 11.9897C3.37497 16.3533 6.06262 20.2668 10.1356 21.8338L11.0033 22.1673C11.7249 22.4453 12.5251 22.4453 13.2472 22.1671L14.1142 21.8339C18.1874 20.2668 20.875 16.3533 20.875 11.9897V5.64469C20.88 4.91559 20.454 4.24742 19.7872 3.94159C17.5145 2.94959 15.0788 2.41997 12.6128 2.37753ZM16.5078 8.44783C16.203 8.16737 15.7285 8.18713 15.4481 8.49195L10.178 14.2188L8.55278 12.4475L8.47188 12.3713C8.18797 12.1409 7.77065 12.1471 7.49311 12.4016C7.18783 12.6815 7.16729 13.156 7.44724 13.4613L9.11067 15.2752L9.21723 15.3803C9.80539 15.9054 10.6977 15.8705 11.2445 15.2762L16.5519 9.50757L16.621 9.42051C16.8265 9.11809 16.7849 8.70279 16.5078 8.44783Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Secure;
